export interface StudioDetails {
  __v: number;
  _id: string;
  access_token: string;
  companyId: string;
  collectPaymentMethod: boolean;
  /**
   * Parent Portal V2: require a payment method when Charge Now > $0.
   * Default true. Locked on when collectPaymentMethod is true.
   */
  requirePaymentMethodForPaidEnrollments?: boolean;
  /** ENR-2726: block parent removal of the last PM while enrolled. Default false. */
  retainPaymentMethodWhileEnrolled?: boolean;
  expires_in: number;
  locationId: string;
  refresh_token: string;
  scope: string;
  subaccountName: string;
  token_type: string;
  userId: string;
  userType: string;
  imageUrl: string;
  paymentProcessingMethod: PaymentProcessingMethod;
  prorationMode:
    | 'full_month_always'
    | 'first_month_only'
    | 'first_and_last_month';
  prorationEnabled?: boolean;
  /** Monthly split. Calendar days unless the studio chooses class meetings. */
  prorationBasis?: 'calendar' | 'session';
  /**
   * When true, class enrollment (single + bulk) uses V2 preview/start APIs.
   * When false/undefined (default), uses legacy add-student-to-entity.
   */
  isV2?: boolean;
  /**
   * When true, for hourly classes a student is enrolled in that share the
   * same rate chart, the studio combines their weekly minutes, looks up
   * the chart once on the combined total, and splits the resulting
   * weekly flat across each class by minute share. Defaults to false.
   */
  combineHourlyMinutesForBestRate?: boolean;
  /**
   * Nested under best-rate: pool sibling weekly minutes on the same chart
   * and equal-split the family band (ENR-2950).
   */
  combineHourlyMinutesAcrossSiblings?: boolean;
  consistentMonthlyHourlyTuition?: boolean;
  familyClassCountTuitionEnabled?: boolean;
  defaultClassCountTuitionBillingId?: string | null;
  failedPaymentRetryCount: number;
  consecutiveAbsencesThreshold: number;
  timezone: string;
  /** When true, scheduled-invoice cron applies payment-run postpone and selective lock. Default false. */
  paymentRunPostponeCronEnabled?: boolean;
  /**
   * Manual-only (ENR-3918). When true, due Upcoming invoices promote to
   * Invoice Scheduled so tuition posts to the parent account without auto-charge.
   * Default false.
   */
  postTuitionToParentAccount?: boolean;
  /** When true, parents choose which charges to pay. Off means oldest-due-first. Default true. */
  allowSelectiveInvoicePayment?: boolean;
  /** When true, a payment may be less than a charge's remaining balance. Default false. */
  allowPartialInvoicePayment?: boolean;
  newDashboard: boolean;
  loginImageEnabled?: boolean;
  loginImageUrl?: string;
  /** Portal banner id this studio has dismissed; new banners reappear when id differs. */
  dismissedPortalBannerId?: string;
  /**
   * Parent Portal branding overrides (ENR-3484).
   * Missing/empty fields keep Enrollio CSS defaults.
   */
  branding?: {
    primaryColor?: string;
    secondaryColor?: string;
    portalDisplayName?: string;
    welcomeHeading?: string;
    welcomeSubtext?: string;
  };
}

export enum PaymentProcessingMethod {
  AUTO = 'auto',
  MANUAL = 'manual',
  SUBSCRIPTION = 'subscription',
}

export interface StudioDetailsAll {
  activeStudentCount: number;
  totalClasses: string;
  totalEvents: string;
  totalStudents: string;
}
